import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'

import FormTextField from '~/components/form/TextField'

import {
  validateTopLevelDomain,
  validateSecondLevelDomain,
} from './utils'

const FormEmailField = props => {
  const {
    name,
    value,
    setValue,
    withEmailSuggestion,
    ...otherProps
  } = props

  const [suggestedEmail, setSuggestedEmail] = useState('')

  useEffect(() => {
    if (withEmailSuggestion) {
      const timer = setTimeout(() => {
        const mistypedTopLevelDomain = validateTopLevelDomain(value)
        if (mistypedTopLevelDomain) {
          setSuggestedEmail(value.replace(mistypedTopLevelDomain.mistypedValue, mistypedTopLevelDomain.correctValue))
        }

        const mistypedSecondLevelDomain = validateSecondLevelDomain(value)
        if (mistypedSecondLevelDomain) {
          setSuggestedEmail(value.replace(mistypedSecondLevelDomain.mistypedValue, mistypedSecondLevelDomain.correctValue))
        }

        if (!mistypedTopLevelDomain && !mistypedSecondLevelDomain) {
          setSuggestedEmail('')
        }
      }, 800)
      return () => clearTimeout(timer)
    }

    return () => {}
  }, [withEmailSuggestion, value])

  const handleSetSuggestedEmail = useCallback(() => {
    setValue(name, suggestedEmail)
    setSuggestedEmail('')
  }, [name, setValue, suggestedEmail, setSuggestedEmail])

  return (
    <FormTextField
      {...otherProps}
      name={name}
      type="email"
      helperText={suggestedEmail ? (
        <p className="text-lightspeed-600">
          Did you mean
          {' '}
          <button
            type="button"
            className="font-semibold"
            onClick={handleSetSuggestedEmail}
          >
            {suggestedEmail}
          </button>
          ?
        </p>
      ) : ''}
    />
  )
}
FormEmailField.propTypes = {
  withEmailSuggestion: PropTypes.bool,
  control: PropTypes.shape({
    register: PropTypes.func.isRequired,
  }).isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  error: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  'data-testid': PropTypes.string,
}
FormEmailField.defaultProps = {
  withEmailSuggestion: true,
  error: '',
  'data-testid': 'form-email-field',
}

// TODO: memoization?
export default FormEmailField
